import { Notification } from '../../types/interfaces/common-interfaces'
import { JoinEventNotification } from './event'
import { ReservationNotification } from './reservation'
import { PlanLimitRefusalNotification } from './plan'
import { NotificationTypes } from './notifications.enum'

type NotificationDataMap = {
  [NotificationTypes.ClientJoinEvent]: JoinEventNotification
  [NotificationTypes.ClientEventCancelled]: JoinEventNotification
  [NotificationTypes.PlanLimitPublicRefusal]: PlanLimitRefusalNotification
  [NotificationTypes.ClientReservationCreated]: ReservationNotification
  [NotificationTypes.ClientReservationCancelled]: ReservationNotification
}

export function narrowNotification<T extends NotificationTypes>(
  notification: Notification,
  type: T,
): notification is Notification<NotificationDataMap[T]> {
  return (notification.data as { type?: NotificationTypes } | undefined)?.type === type
}
